"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRequests = createRequests;
function createRequests() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp,
    res = p.res;
  var target = wapp.getTargetObject();
  var globalGraphqlConfig = target.config && target.config.graphql ? target.config.graphql : {};
  var requestManager = wapp.requests.requestManager;
  var _globalGraphqlConfig$ = globalGraphqlConfig.route,
    route = _globalGraphqlConfig$ === void 0 ? "/graphql" : _globalGraphqlConfig$;
  var graphql = res.wappResponse.store.getState("res.graphql") || {};
  function addRequest(resolver, requestName) {
    var url = resolver.url || route;
    var query = resolver.query;
    if (query && !requestManager.requests[requestName]) {
      var options = {
        getBody: function getBody() {
          var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (p.multipart) {
            var formData = typeof FormData !== 'undefined' ? new FormData() : null;
            var _r = {
              query: query,
              variables: p.args || {}
            };
            if (formData) {
              formData.append("operations", JSON.stringify(_r));
            }
            if (p.callbackMultipartFormData) {
              var newFormData = p.callbackMultipartFormData({
                formData: formData,
                body: {
                  operations: _r
                }
              });
              if (newFormData) {
                formData = newFormData;
              }
            }
            return formData;
          }
          var r = {
            query: query,
            variables: p.args || {}
          };
          return JSON.stringify(r);
        }
      };
      requestManager.setNewRequest({
        requestName: requestName,
        url: url,
        options: options
      });
    }
  }
  if (graphql.mutation) {
    Object.keys(graphql.mutation).forEach(function (requestName) {
      addRequest(graphql.mutation[requestName], requestName);
    });
  }
  if (graphql.query) {
    Object.keys(graphql.query).forEach(function (requestName) {
      addRequest(graphql.query[requestName], requestName);
    });
  }
}